import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Resets scroll to the top on every route change. Without this, navigating
// from a page scrolled partway down lands the next page at the same offset.
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Reset the document scroll (the app body scrolls under a fixed bottom nav).
    window.scrollTo(0, 0)
    const el = document.scrollingElement || document.documentElement
    if (el) el.scrollTop = 0
  }, [pathname])

  return null
}
